<div class="page-shell">
  <div class="page">
    <div class="hero">
      <div class="hero-text">
        <span class="eyebrow">Atlas</span>
        <h2>Checkout canceled</h2>
        <p>Your checkout was canceled. You can choose a plan and try again.</p>
      </div>
      <div class="hero-panel">
        <div class="step-pill">Paused</div>
        <div class="hero-title">No charge</div>
        <div class="hero-subtitle">Return when you are ready.</div>
      </div>
    </div>

    <section class="card">
      <h3>Ready to continue?</h3>
      <p>Select your plan again to restart checkout.</p>
      <div class="actions">
        <a class="primary-link" [href]="returnToSubscriptionUrl">Return to subscription</a>
        <a class="secondary-link" href="/atlas-signup">Start a new Atlas signup</a>
      </div>
      @if (!tenantId) {
      <div class="helper">
        @if (returnUrl) {
        <a class="secondary-link" [href]="returnUrl">Back to portal</a>
        }
        @if (!returnUrl) {
        If you came from the portal, return there to restart the flow.
        }
      </div>
      }
    </section>
  </div>
</div>